import { render } from "./json-editor.vue?vue&type=template&id=62421bff"
import script from "./json-editor.vue?vue&type=script&lang=js"
export * from "./json-editor.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__